<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="pb-12">
          <setup-disciplines-container-view />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    components: {
      SetupDisciplinesContainerView: () => import('@/components/hris/setup/disciplines/ContainerView'),
    },
  }
</script>
